import type { I18nFn } from '#/i18n/types/I18nFn';

export enum AreaOfFocus {
  AGRICULTURE = 'AGRICULTURE',
  ANIMALS = 'ANIMALS',
  ARTS_MUSIC = 'ARTS_MUSIC',
  CHILDREN_YOUTH = 'CHILDREN_YOUTH',
  CIVIC_ENGAGEMENT = 'CIVIC_ENGAGEMENT',
  CLIMATE_CHANGE = 'CLIMATE_CHANGE',
  COMMUNICATIONS_ACCESS = 'COMMUNICATIONS_ACCESS',
  COMMUNITY_DEVELOPMENT = 'COMMUNITY_DEVELOPMENT',
  CONFLICT_RESOLUTION = 'CONFLICT_RESOLUTION',
  CONSUMER_PROTECTION = 'CONSUMER_PROTECTION',
  CRIME_SAFETY = 'CRIME_SAFETY',
  DISABILITY = 'DISABILITY',
  DISASTER_RELIEF = 'DISASTER_RELIEF',
  ECONOMIC_DEVELOPMENT = 'ECONOMIC_DEVELOPMENT',
  EDUCATION = 'EDUCATION',
  ENERGY = 'ENERGY',
  ENTREPRENEURSHIP = 'ENTREPRENEURSHIP',
  ENVIRONMENT = 'ENVIRONMENT',
  FAMILY = 'FAMILY',
  FINANCIAL_LITERACY_PERSONAL_FINANCE = 'FINANCIAL_LITERACY_PERSONAL_FINANCE',
  HEALTH_MEDICINE = 'HEALTH_MEDICINE',
  HOUSING_HOMELESSNESS = 'HOUSING_HOMELESSNESS',
  HUMAN_RIGHTS_CIVIL_LIBERTIES = 'HUMAN_RIGHTS_CIVIL_LIBERTIES',
  HUNGER_FOOD_SECURITY = 'HUNGER_FOOD_SECURITY',
  IMMIGRANTS_OR_REFUGEES = 'IMMIGRANTS_OR_REFUGEES',
  INTERNATIONAL_RELATIONS = 'INTERNATIONAL_RELATIONS',
  JOB_WORKPLACE = 'JOB_WORKPLACE',
  LEGAL_ASSISTANCE = 'LEGAL_ASSISTANCE',
  LGBTQ = 'LGBTQ',
  MEDIA = 'MEDIA',
  MEN = 'MEN',
  MENTAL_HEALTH = 'MENTAL_HEALTH',
  MICROFINANCE = 'MICROFINANCE',
  PHILANTHROPY = 'PHILANTHROPY',
  POLICY = 'POLICY',
  POVERTY = 'POVERTY',
  PRISON_REFORM = 'PRISON_REFORM',
  RACE_ETHNICITY = 'RACE_ETHNICITY',
  RELIGION_SPIRITUALITY = 'RELIGION_SPIRITUALITY',
  REPRODUCTIVE_HEALTH_RIGHTS = 'REPRODUCTIVE_HEALTH_RIGHTS',
  RESEARCH_SOCIAL_SCIENCE = 'RESEARCH_SOCIAL_SCIENCE',
  RURAL_AREAS = 'RURAL_AREAS',
  SCIENCE_TECHNOLOGY = 'SCIENCE_TECHNOLOGY',
  SENIORS_RETIREMENT = 'SENIORS_RETIREMENT',
  SEXUAL_ABUSE_HUMAN_TRAFFICKING = 'SEXUAL_ABUSE_HUMAN_TRAFFICKING',
  SPORTS_RECREATION = 'SPORTS_RECREATION',
  SUBSTANCE_ABUSE_ADDICTION = 'SUBSTANCE_ABUSE_ADDICTION',
  TRAVEL_HOSPITALITY = 'TRAVEL_HOSPITALITY',
  TRANSPARENCY_OVERSIGHT = 'TRANSPARENCY_OVERSIGHT',
  TRANSPORTATION = 'TRANSPORTATION',
  URBAN_AREAS = 'URBAN_AREAS',
  VETERANS = 'VETERANS',
  VICTIM_SUPPORT = 'VICTIM_SUPPORT',
  VOLUNTEERING = 'VOLUNTEERING',
  WATER_SANITATION = 'WATER_SANITATION',
  WOMEN = 'WOMEN',
}

export function AREAS_OF_FOCUS(i18n: I18nFn) {
  return {
    [AreaOfFocus.AGRICULTURE]: i18n('Agriculture'),
    [AreaOfFocus.ANIMALS]: i18n('Animals'),
    [AreaOfFocus.ARTS_MUSIC]: i18n('Arts & Music'),
    [AreaOfFocus.CHILDREN_YOUTH]: i18n('Children & Youth'),
    [AreaOfFocus.CIVIC_ENGAGEMENT]: i18n('Civic Engagement'),
    [AreaOfFocus.CLIMATE_CHANGE]: i18n('Climate Change'),
    [AreaOfFocus.COMMUNICATIONS_ACCESS]: i18n('Communications Access'),
    [AreaOfFocus.COMMUNITY_DEVELOPMENT]: i18n('Community Development'),
    [AreaOfFocus.CONFLICT_RESOLUTION]: i18n('Conflict Resolution'),
    [AreaOfFocus.CONSUMER_PROTECTION]: i18n('Consumer Protection'),
    [AreaOfFocus.CRIME_SAFETY]: i18n('Crime & Safety'),
    [AreaOfFocus.DISABILITY]: i18n('Disability'),
    [AreaOfFocus.DISASTER_RELIEF]: i18n('Disaster Relief'),
    [AreaOfFocus.ECONOMIC_DEVELOPMENT]: i18n('Economic Development'),
    [AreaOfFocus.EDUCATION]: i18n('Education'),
    [AreaOfFocus.ENERGY]: i18n('Energy'),
    [AreaOfFocus.ENTREPRENEURSHIP]: i18n('Entrepreneurship'),
    [AreaOfFocus.ENVIRONMENT]: i18n('Environment & Sustainability'),
    [AreaOfFocus.FAMILY]: i18n('Family'),
    [AreaOfFocus.FINANCIAL_LITERACY_PERSONAL_FINANCE]: i18n(
      'Financial Literacy & Personal Finance',
    ),
    [AreaOfFocus.HEALTH_MEDICINE]: i18n('Health & Medicine'),
    [AreaOfFocus.HOUSING_HOMELESSNESS]: i18n('Housing & Homelessness'),
    [AreaOfFocus.HUMAN_RIGHTS_CIVIL_LIBERTIES]: i18n(
      'Human Rights & Civil Liberties',
    ),
    [AreaOfFocus.HUNGER_FOOD_SECURITY]: i18n('Hunger, Food Security'),
    [AreaOfFocus.IMMIGRANTS_OR_REFUGEES]: i18n('Immigrants or Refugees'),
    [AreaOfFocus.INTERNATIONAL_RELATIONS]: i18n('International Relations'),
    [AreaOfFocus.JOB_WORKPLACE]: i18n('Job & Workplace'),
    [AreaOfFocus.LEGAL_ASSISTANCE]: i18n('Legal Assistance'),
    [AreaOfFocus.LGBTQ]: i18n('LGBTQ'),
    [AreaOfFocus.MEDIA]: i18n('Media'),
    [AreaOfFocus.MEN]: i18n('Men'),
    [AreaOfFocus.MENTAL_HEALTH]: i18n('Mental Health'),
    [AreaOfFocus.MICROFINANCE]: i18n('Microfinance'),
    [AreaOfFocus.PHILANTHROPY]: i18n('Philanthropy'),
    [AreaOfFocus.POLICY]: i18n('Policy'),
    [AreaOfFocus.POVERTY]: i18n('Poverty'),
    [AreaOfFocus.PRISON_REFORM]: i18n('Prison Reform'),
    [AreaOfFocus.RACE_ETHNICITY]: i18n('Race & Ethnicity'),
    [AreaOfFocus.RELIGION_SPIRITUALITY]: i18n('Religion & Spirituality'),
    [AreaOfFocus.REPRODUCTIVE_HEALTH_RIGHTS]: i18n(
      'Reproductive Health/Rights',
    ),
    [AreaOfFocus.RESEARCH_SOCIAL_SCIENCE]: i18n('Research & Social Science'),
    [AreaOfFocus.RURAL_AREAS]: i18n('Rural Areas'),
    [AreaOfFocus.SCIENCE_TECHNOLOGY]: i18n('Science & Technology'),
    [AreaOfFocus.SENIORS_RETIREMENT]: i18n('Seniors & Retirement'),
    [AreaOfFocus.SEXUAL_ABUSE_HUMAN_TRAFFICKING]: i18n(
      'Sexual Abuse & Human Trafficking',
    ),
    [AreaOfFocus.SPORTS_RECREATION]: i18n('Sports & Recreation'),
    [AreaOfFocus.SUBSTANCE_ABUSE_ADDICTION]: i18n('Substance Use & Addiction'),
    [AreaOfFocus.TRAVEL_HOSPITALITY]: i18n('Travel & Hospitality'),
    [AreaOfFocus.TRANSPARENCY_OVERSIGHT]: i18n('Transparency & Oversight'),
    [AreaOfFocus.TRANSPORTATION]: i18n('Transportation'),
    [AreaOfFocus.URBAN_AREAS]: i18n('Urban Areas'),
    [AreaOfFocus.VETERANS]: i18n('Veterans'),
    [AreaOfFocus.VICTIM_SUPPORT]: i18n('Victim Support'),
    [AreaOfFocus.VOLUNTEERING]: i18n('Volunteering'),
    [AreaOfFocus.WATER_SANITATION]: i18n('Water & Sanitation'),
    [AreaOfFocus.WOMEN]: i18n('Women'),
  } satisfies Record<AreaOfFocus, string>;
}

export function AREAS_OF_FOCUS_RADIO_OR_SELECT_OPTIONS(i18n: I18nFn) {
  return Object.entries(AREAS_OF_FOCUS(i18n))
    .sort(([, a], [, b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      value: key as keyof typeof AREAS_OF_FOCUS,
      label: value,
    }));
}

export function AREAS_OF_FOCUS_CHECKBOX_OPTIONS(i18n: I18nFn) {
  return Object.entries(AREAS_OF_FOCUS(i18n))
    .sort(([, a], [, b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      name: key as keyof typeof AREAS_OF_FOCUS,
      label: value,
    }));
}
